import { render, staticRenderFns } from "./bindSizeGroupModal.vue?vue&type=template&id=37cb00bc&scoped=true&"
import script from "./bindSizeGroupModal.vue?vue&type=script&lang=js&"
export * from "./bindSizeGroupModal.vue?vue&type=script&lang=js&"
import style0 from "./bindSizeGroupModal.vue?vue&type=style&index=0&id=37cb00bc&prod&lang=less&scoped=true&"
import style1 from "./bindSizeGroupModal.vue?vue&type=style&index=1&id=37cb00bc&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37cb00bc",
  null
  
)

export default component.exports